import { Gender } from "../../../common/interfaces/enums/Gender";
import { HttpMethod } from "../../enums/HttpMethod";
import { apiFetch } from "../helpers";

interface ICoverAmounts {
    index: number;
    label: string;
    value: number[];
}

interface ILifeCompareData {
    mostPopular: number;
    average: number;
    coverAmounts: ICoverAmounts[];
}

export const getLifeCoverAmounts = (
    min: number,
    max: number,
    minAge: number,
    maxAge: number,
    isSmoker: boolean,
    gender: Gender
): Promise<ILifeCompareData> => {
    const baseURL = "/api/life/calculator/coveramounts";

    return apiFetch(
        `${baseURL}?Min=${min}&Max=${max}&MinAge=${minAge}&MaxAge=${maxAge}&IsSmoker=${isSmoker}&Gender=${gender}`,
        {
            method: HttpMethod.Get,
            headers: {
                "content-type": "application/json"
            }
        }
    );
};
